import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Input, Label, Button } from 'reactstrap';

import './StaticField.scss';

class StaticField extends Component {
  render() {
    let hiddenClass = "";
    if(this.props.hidden) {
      hiddenClass = " hidden";
    }

    let label;
    if(this.props.label !== "") {
      label = <Label for="name">{this.props.label}</Label>
    }
    
    let value;
    if(this.props.value !== "") {
      value = <Input plaintext value={this.props.value} readOnly />
    }
    else {
      value = this.props.children;
    }
    return (
      <div className={"static-field" + hiddenClass}>
        <FormGroup>
          {label}
          {value}
          {(!this.props.disableEdit) ?
            <Button className="edit-button" onClick={this.props.onClickEdit} />          
            : <div />
          }
        </FormGroup>
      </div>);
  }
}
StaticField.defaultProps= {
  onClickEdit: () => {},  
  disableEdit: false,
  hidden: false,
  label: "",
  value: ""
};

StaticField.propTypes = {
  onClickEdit: PropTypes.func,  
  disableEdit: PropTypes.bool,
  hidden: PropTypes.bool,
  label: PropTypes.string,
  value: PropTypes.string
};

export default StaticField;


// WEBPACK FOOTER //
// ./src/components/StaticField/StaticField.js